/**
 * Employee Incident List Mapper
 * Maps transport layer DTOs to domain models for self-service incident listing
 */
import type {
  LC_ListIncidentsOut,
  LC_IncidentItemOut,
  IncidentItem,
  IncidentTotals,
  IncidentListResult,
} from '../types';
import { formatDateToDDMMYYYY } from './employeeIncidentCommon.mapper';
import { capitalizeFirst } from '@/utils';

/**
 * Maps single incident item from backend to UI model
 */
export function mapIncidentItemOut(item: LC_IncidentItemOut): IncidentItem {
  return {
    id: item.incidentId,
    errorType: item.errorType ? capitalizeFirst(item.errorType) : '-',
    incidentDate: formatDateToDDMMYYYY(item.incidentDate),
    checkInDate: formatDateToDDMMYYYY(item.checkInDate),
    checkInTime: item.checkInTime || '-',
    location: item.location || '-',
    status: item.status ? capitalizeFirst(item.status) : '-',
  };
}

/**
 * Extracts totals from pagination metadata
 */
export function mapIncidentTotals(pagination: LC_ListIncidentsOut['pagination']): IncidentTotals {
  return {
    pendientes: pagination.totalPending,
    aprobados: pagination.totalApproved,
    rechazados: pagination.totalRejected,
    error: pagination.totalError,
    todos: pagination.totalAll,
  };
}

/**
 * Maps complete list response from backend to UI model
 */
export function mapIncidentListResponse(response: LC_ListIncidentsOut): IncidentListResult {
  const data = response.data?.map(mapIncidentItemOut) || [];
  const totals = mapIncidentTotals(response.pagination);
  const totalRecords = response.pagination.totalRecords;

  return {
    data,
    totals,
    totalRecords,
  };
}
